module.exports = __webpack_public_path__ + "img/down-phz3.ccc13509.jpg";